import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="container">
        <p>&copy; {currentYear} Eva Baris | communicatie | marketing | tekst | storytelling</p>
      </div>
    </footer>
  );
};

export default Footer;